<template>
  <div class="d-flex flex-column align-center mt-6 mb-6 ga-2">
    <div class="title">
      {{$t('Выберите язык')}}
    </div>
    <div class="description">
      {{$t('Укажите, на каком языке вы сейчас заполняете страницу. Он станет основным языком страницы')}}
    </div>
  </div>
  <div class="d-flex flex-column ga-2">
    <v-btn variant="outlined" color="accent" rounded="lg" class="w-100" @click="openLangOrder('kz')">
      {{$t('KZ')}}
    </v-btn>
    <v-btn variant="outlined" color="accent" rounded="lg" class="w-100" @click="openLangOrder('ru')">
      {{$t('RU')}}
    </v-btn>
    <v-btn variant="outlined" color="accent" rounded="lg" class="w-100" @click="openLangOrder('en')">
      {{$t('EN')}}
    </v-btn>
  </div>
</template>

<script setup lang="ts">
import {useDialogStore} from "@/stores/dialogStore";
import LangOrder from "@/components/dialogs/LanguageOrder.vue";
import {useTapStore} from "@/stores/tapStore";
import {onMounted} from "vue";

const tapStore = useTapStore()
const dialogStore = useDialogStore()

const openLangOrder = (lang: string) => {
  tapStore.setDefaultLang(lang)
  dialogStore.open(LangOrder)
}

onMounted(() => {
  const haveLangs = tapStore.languageSettings.filter(l => l.active || l.edited).length > 1
  if(haveLangs) {
    dialogStore.open(LangOrder)
  }
})
</script>

<style scoped lang="sass">
.title
  color: #000
  text-align: center
  font-size: 20px
  font-style: normal
  font-weight: 600
  line-height: normal
.description
  color: #363636
  text-align: center
  font-size: 14px
  font-style: normal
  font-weight: 400
  line-height: normal
  max-width: 270px
</style>
